import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
  IAddStudyRequest,
  IStudy,
  IUpdateStudyRequest,
} from "../../../@types/admin/AdminStudy";
import { studiesService } from "../../../services/admin";
import { ensureOk } from "../../../utils/ensureOk";

export function useAddStudy() {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation<
    IStudy,
    Error,
    IAddStudyRequest
  >({
    mutationFn: async (request) =>
      ensureOk(await studiesService.addStudy(request)),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["admin-studies"] });
    },
  });

  return { addStudy: mutateAsync, isAddingStudy: isPending };
}

export function useUpdateStudy() {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation<
    IStudy,
    Error,
    IUpdateStudyRequest
  >({
    mutationFn: async (request) =>
      ensureOk(await studiesService.updateStudy(request)),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["admin-studies"] });
    },
  });

  return { updateStudy: mutateAsync, isUpdatingStudy: isPending };
}
